import _actions_reform from './_actions/reform.js'
import _actions_filter from './_actions/filter.js'
import _actions_change from './_actions/change.js'
import _getters_filters from './_getters/filters.js'
import _getters_data_report from './_getters/data_report.js'
import _getters_data from './_getters/data.js'
import _mutations_set from './_mutations/set.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        set: _mutations_set,
    },
    getters:{
        data: _getters_data,
        data_report: _getters_data_report,
        filters: _getters_filters,
    },
    actions:{
        change: _actions_change,
        filter: _actions_filter,
        reform: _actions_reform,
    },
}